import { render, staticRenderFns } from "./DialogChainsOrChannels.vue?vue&type=template&id=2fe1419e"
import script from "./DialogChainsOrChannels.vue?vue&type=script&lang=js"
export * from "./DialogChainsOrChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports